import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

interface ModelCardProps {
  id: string
  name: string
  stageName?: string
  profileImage?: string
  videoCount?: number
  index?: number
}

export default function ModelCard({ 
  id, 
  name, 
  stageName, 
  profileImage, 
  videoCount = 0,
  index = 0 
}: ModelCardProps) {
  const { t } = useTranslation()

  return (
    <Link to={`/models/${id}`} style={{ textDecoration: 'none' }}>
      <article className="model-card">
        {profileImage ? (
          <img src={profileImage} alt={stageName || name} className="model-avatar" />
        ) : (
          <div 
            className="model-avatar"
            style={{ 
              background: `linear-gradient(135deg, hsl(${index * 60}, 50%, 30%) 0%, hsl(${index * 60}, 40%, 20%) 100%)`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#666" strokeWidth="1">
              <circle cx="12" cy="8" r="4"/>
              <path d="M20 21a8 8 0 1 0-16 0"/>
            </svg>
          </div>
        )}
        <h4 className="model-name">{stageName || name}</h4>
        <p className="model-stats">{t('common.videos_count', { count: videoCount })}</p>
      </article>
    </Link>
  )
}
